module.exports = __webpack_public_path__ + "static/media/soilTemperature.dcef1732.svg";